import React from "react";
import { useSelector } from "react-redux";
import { Content, MessageContainer } from "../../styled";
import ErrorIcon from "../../../Icons/ErrorIcon";
import { message } from "../../../../../store/General/selectors";

const ErrorAlert = () => {
  const resultMessage = useSelector(message);
  return (
    <Content>
      <ErrorIcon />
      <MessageContainer>{resultMessage}</MessageContainer>
    </Content>
  );
};

export default ErrorAlert;
